/* === HTML Alert Modal (global helper) === */
(function(){
  if (typeof window.showHtmlAlert === 'function') return;

  function ensureAlertDom(){
    let overlay = document.getElementById('ww-alert-overlay');
    if (overlay) return;

    overlay = document.createElement('div');
    overlay.id = 'ww-alert-overlay';
    overlay.style.position = 'fixed';
    overlay.style.inset = '0';
    overlay.style.background = 'rgba(0,0,0,0.4)';
    overlay.style.display = 'none';
    overlay.style.alignItems = 'center';
    overlay.style.justifyContent = 'center';
    overlay.style.zIndex = '99999';

    const box = document.createElement('div');
    box.id = 'ww-alert-box';
    box.style.background = '#fff';
    box.style.padding = '20px 24px';
    box.style.borderRadius = '10px';
    box.style.maxWidth = '520px';
    box.style.width = 'min(90vw, 520px)';
    box.style.boxShadow = '0 10px 30px rgba(0,0,0,0.2)';
    box.style.fontFamily = 'system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif';

    const msg = document.createElement('div');
    msg.id = 'ww-alert-message';
    msg.style.whiteSpace = 'pre-wrap';
    msg.style.fontSize = '15px';
    msg.style.lineHeight = '1.4';
    msg.style.color = '#111';
    msg.style.marginBottom = '16px';

    const actions = document.createElement('div');
    actions.style.display = 'flex';
    actions.style.justifyContent = 'flex-end';
    actions.style.gap = '8px';

    const ok = document.createElement('button');
    ok.id = 'ww-alert-ok';
    ok.textContent = 'OK';
    ok.style.padding = '8px 14px';
    ok.style.border = '1px solid #111';
    ok.style.background = '#111';
    ok.style.color = '#fff';
    ok.style.borderRadius = '8px';
    ok.style.cursor = 'pointer';

    actions.appendChild(ok);
    box.appendChild(msg);
    box.appendChild(actions);
    overlay.appendChild(box);
    document.body.appendChild(overlay);

    overlay.addEventListener('click', (e)=>{ if (e.target === overlay) hideHtmlAlert(); });
    ok.addEventListener('click', hideHtmlAlert);
    document.addEventListener('keydown', (e)=>{ if (overlay.style.display !== 'none' && e.key === 'Escape') hideHtmlAlert(); });
  }

  window.showHtmlAlert = function(message){
    try { ensureAlertDom(); } catch(e){ console.warn(e); return; }
    const overlay = document.getElementById('ww-alert-overlay');
    const msg = document.getElementById('ww-alert-message');
    msg.textContent = String(message ?? '');
    overlay.style.display = 'flex';
    const ok = document.getElementById('ww-alert-ok');
    if (ok) ok.focus();
  };

  window.hideHtmlAlert = function(){
    const overlay = document.getElementById('ww-alert-overlay');
    if (overlay) overlay.style.display = 'none';
  };

  // Optional: promise-based version for async/await
  window.showHtmlAlertAsync = function(message){
    return new Promise((resolve) => {
      showHtmlAlert(message);
      const ok = document.getElementById('ww-alert-ok');
      const overlay = document.getElementById('ww-alert-overlay');
      const cleanup = () => {
        overlay?.removeEventListener('click', overlayClick);
        ok?.removeEventListener('click', okClick);
        document.removeEventListener('keydown', esc);
        resolve();
      };
      const okClick = () => { hideHtmlAlert(); cleanup(); };
      const overlayClick = (e) => { if (e.target === overlay) { hideHtmlAlert(); cleanup(); } };
      const esc = (e) => { if (e.key === 'Escape') { hideHtmlAlert(); cleanup(); } };
      ok?.addEventListener('click', okClick);
      overlay?.addEventListener('click', overlayClick);
      document.addEventListener('keydown', esc);
    });
  };
})();

// === HTML Confirm Modal (global helper) ===
(function(){
  if (typeof window.showHtmlConfirm === 'function') return;

  function ensureConfirmDom(){
    let overlay = document.getElementById('ww-confirm-overlay');
    if (overlay) return;

    overlay = document.createElement('div');
    overlay.id = 'ww-confirm-overlay';
    overlay.style.position = 'fixed';
    overlay.style.inset = '0';
    overlay.style.background = 'rgba(0,0,0,0.4)';
    overlay.style.display = 'none';
    overlay.style.alignItems = 'center';
    overlay.style.justifyContent = 'center';
    overlay.style.zIndex = '99999';

    const box = document.createElement('div');
    box.id = 'ww-confirm-box';
    box.style.background = '#fff';
    box.style.padding = '20px 24px';
    box.style.borderRadius = '10px';
    box.style.maxWidth = '520px';
    box.style.width = 'min(90vw, 520px)';
    box.style.boxShadow = '0 10px 30px rgba(0,0,0,0.2)';
    box.style.fontFamily = 'system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif';

    const msg = document.createElement('div');
    msg.id = 'ww-confirm-message';
    msg.style.whiteSpace = 'pre-wrap';
    msg.style.fontSize = '15px';
    msg.style.lineHeight = '1.4';
    msg.style.color = '#111';
    msg.style.marginBottom = '16px';

    const actions = document.createElement('div');
    actions.style.display = 'flex';
    actions.style.justifyContent = 'flex-end';
    actions.style.gap = '8px';

    const cancelBtn = document.createElement('button');
    cancelBtn.id = 'ww-confirm-cancel';
    cancelBtn.textContent = 'Cancel';
    cancelBtn.style.padding = '8px 14px';
    cancelBtn.style.border = '1px solid #666';
    cancelBtn.style.background = '#fff';
    cancelBtn.style.color = '#111';
    cancelBtn.style.borderRadius = '8px';
    cancelBtn.style.cursor = 'pointer';

    const okBtn = document.createElement('button');
    okBtn.id = 'ww-confirm-ok';
    okBtn.textContent = 'OK';
    okBtn.style.padding = '8px 14px';
    okBtn.style.border = '1px solid #111';
    okBtn.style.background = '#111';
    okBtn.style.color = '#fff';
    okBtn.style.borderRadius = '8px';
    okBtn.style.cursor = 'pointer';

    actions.appendChild(cancelBtn);
    actions.appendChild(okBtn);
    box.appendChild(msg);
    box.appendChild(actions);
    overlay.appendChild(box);
    document.body.appendChild(overlay);

    overlay.addEventListener('click', (e)=>{ if (e.target === overlay) hideHtmlConfirm(); });
    document.addEventListener('keydown', (e)=>{ if (overlay.style.display !== 'none' && e.key === 'Escape') hideHtmlConfirm(); });
  }

  window.showHtmlConfirm = function(message, onConfirm, onCancel){
    try { ensureConfirmDom(); } catch(e){ console.warn(e); return; }
    const overlay = document.getElementById('ww-confirm-overlay');
    const msg = document.getElementById('ww-confirm-message');
    msg.textContent = String(message ?? '');
    overlay.style.display = 'flex';

    const okBtn = document.getElementById('ww-confirm-ok');
    const cancelBtn = document.getElementById('ww-confirm-cancel');

    const cleanup = () => {
      okBtn.removeEventListener('click', okHandler);
      cancelBtn.removeEventListener('click', cancelHandler);
    };
    const okHandler = () => { hideHtmlConfirm(); cleanup(); if (typeof onConfirm === 'function') onConfirm(); };
    const cancelHandler = () => { hideHtmlConfirm(); cleanup(); if (typeof onCancel === 'function') onCancel(); };

    okBtn.addEventListener('click', okHandler);
    cancelBtn.addEventListener('click', cancelHandler);
    okBtn.focus();
  };

  window.hideHtmlConfirm = function(){
    const overlay = document.getElementById('ww-confirm-overlay');
    if (overlay) overlay.style.display = 'none';
  };

  // Optional: promise-based usage
  window.showHtmlConfirmAsync = function(message){
    return new Promise((resolve) => {
      showHtmlConfirm(message, () => resolve(true), () => resolve(false));
    });
  };
})();